import { Button } from "@/components/ui/button";
import { ArrowRight, Play, TrendingUp, Shield, Zap } from "lucide-react";
import heroImage from "@/assets/hero-ai-datacenter.jpg";
import { useNavigate } from "react-router-dom";
export const HeroSection = () => {
  const navigate = useNavigate();
  const features = [{
    icon: Shield,
    title: "Data Privacy",
    description: "Keep your data on-premises with complete control"
  }, {
    icon: Zap,
    title: "Low Latency",
    description: "Sub-100ms inference times for real-time applications"
  }, {
    icon: TrendingUp,
    title: "Cost Control",
    description: "Predictable costs without per-token pricing"
  }];
  return <section className="relative overflow-hidden bg-gradient-to-br from-background via-muted/30 to-background">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img src={heroImage} alt="Enterprise AI Infrastructure" className="w-full h-full object-cover opacity-5" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/70 to-background/90" />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-24 lg:py-32">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Main Headline */}
          <div className="space-y-4 animate-fade-up">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
              On-Premises{" "}
              <span className="bg-gradient-primary bg-clip-text text-transparent">
                GenAI Inference
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Deploy enterprise-grade AI models with Intel and Dell infrastructure. 
              Maintain data sovereignty while achieving cloud-scale performance.
            </p>
          </div>

          {/* CTA Buttons */}
          <div data-tour="hero-cta" className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Button 
              size="lg" 
              className="bg-gradient-primary hover:shadow-glow transition-smooth text-lg px-8 py-6 h-auto group" 
              onClick={() => navigate("/wizard")}
            >
              <Zap className="mr-2 h-5 w-5 group-hover:scale-110 transition-transform" />
              Start Configuration Wizard
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>

            <Button 
              variant="outline" 
              size="lg" 
              className="text-lg px-8 py-6 h-auto hover:bg-card-hover transition-smooth" 
              onClick={() => navigate("/demos")}
            >
              <Play className="mr-2 h-4 w-4" />
              Try Live Demos
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="pt-12 space-y-6">
            
            
            {/* Logo Placeholder - would be replaced with actual client logos */}
            <div className="flex items-center justify-center space-x-8 opacity-60">
              <div className="h-8 w-24 bg-muted rounded"></div>
              <div className="h-8 w-20 bg-muted rounded"></div>
              <div className="h-8 w-28 bg-muted rounded"></div>
              <div className="h-8 w-24 bg-muted rounded"></div>
            </div>
          </div>
        </div>

        {/* Feature Highlights */}
        <div className="max-w-6xl mx-auto mt-20 grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => <div key={feature.title} className="text-center space-y-4 p-6 rounded-2xl bg-card/50 backdrop-blur border shadow-card hover:shadow-elegant transition-smooth animate-fade-up" style={{
          animationDelay: `${index * 200}ms`
        }}>
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-primary text-white">
                <feature.icon className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};